import { render, staticRenderFns } from "./SymbolTable.vue?vue&type=template&id=678e70a6&scoped=true"
import script from "./SymbolTable.vue?vue&type=script&lang=js"
export * from "./SymbolTable.vue?vue&type=script&lang=js"
import style0 from "./SymbolTable.vue?vue&type=style&index=0&id=678e70a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678e70a6",
  null
  
)

export default component.exports